import * as GUI from "babylonjs-gui";
import { Joystick } from "./joystick.model";
import { PopUp } from "./popUp.model";

export class UIElements{  
     
    constructor(canvas, advancedTexture){
        this.canvas = canvas;
        this.advancedTexture = advancedTexture;
        this.buttonSizeStandard = (this.canvas.width/4)-((this.canvas.width/this.canvas.height)*100);
        this.buttonSizeBig = this.buttonSizeStandard*1.3;
        if(this.canvas.width < this.canvas.height)
            this.smallestDimension = this.canvas.width;
        else    
            this.smallestDimension = this.canvas.height;

        console.log(canvas);

        this.imageLogo = null;
        this.imageARInstructions = null;
        this.imageControlPanel = null;
        this.imageProcedureComplete = null;
        this.joystickLeft = null;
        this.joystickRight = null;
        this.popUp = null;
        this.buttonARPlaceProduct = null;
        this.buttonARToggleOn = null;
        this.buttonARToggleOff = null;
        this.buttonControlPanelPower = null;
        this.buttonControlPanelControl = null;
        this.buttonHome = null;
        this.buttonsAnimationType = [];
        this.textStepDescription = null;
        this.textPopUpDescription = null;
        this.textButtonExplainer = null;
        this.panelTextBoxBoundary = null;
        this.panelPopUpBoundary = null;
        this.blackout = null;
        this.sliderZoom = null;
        this.gridAnimationTypeButtons = null;
        this.gridControlPanel = null;
        this.menuIsActive = true;
        this.isARSupported = false;
    }

    displayAnimationScreen() {
        this.gridAnimationTypeButtons.isEnabled = false;
        this.gridAnimationTypeButtons.isVisible = false;
        this.isVisible = false;
        this.buttonHome.isEnabled = true;
        this.buttonHome.isVisible = true;
        //this.imageLogo.isVisible = false;
        this.menuIsActive = false;
        this.textButtonExplainer.isVisible = false;
    }

    displayMenuScreen() {
        this.gridAnimationTypeButtons.isEnabled = true;
        this.gridAnimationTypeButtons.isVisible = true;
        this.buttonHome.isEnabled = false;
        this.buttonHome.isVisible = false;
        /* if(this.isARSupported){
            if(this.buttonARPlaceProduct.background != "red" && this.buttonHome.isVisible != true)
                this.imageLogo.isVisible = true;
        } */
        this.panelTextBoxBoundary.isVisible = false;
        this.joystickLeft.setJoystickVisibility(false);
        this.joystickRight.setJoystickVisibility(false);
        this.imageControlPanel.isVisible = false;
        this.gridControlPanel.isVisible = false;
        this.imageProcedureComplete.isVisible = false;
        this.menuIsActive = true;
        this.textButtonExplainer.isVisible = true;
    }

    createLogo(){
        this.imageLogo = new GUI.Image("but", "https://charliebehan.github.io/DromoneARDemo/textures/dromone-logo-footer.png");
        this.imageLogo.width = "519px";
        this.imageLogo.height = "90px";
        this.imageLogo.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.imageLogo.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        this.imageLogo.top = "19px";
        this.imageLogo.paddingLeft = "19px";
        this.advancedTexture.addControl(this.imageLogo);
    }

    createStepDescription(){
        this.panelTextBoxBoundary = new GUI.Rectangle();
        this.panelTextBoxBoundary.widthInPixels = this.canvas.width*0.7;
        this.panelTextBoxBoundary.heightInPixels = this.canvas.height/3;
        this.panelTextBoxBoundary.color = "transparent";
        this.panelTextBoxBoundary.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        this.panelTextBoxBoundary.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        this.panelTextBoxBoundary.isVisible = false;
        this.advancedTexture.addControl(this.panelTextBoxBoundary);   
        
        this.textStepDescription = new GUI.TextBlock();
        this.textStepDescription.textWrapping = true;
        this.textStepDescription.text = "Step Description goes here .. ... ... ... .. ..";
        this.textStepDescription.color = "white";
        this.textStepDescription.outlineColor = "black";
        this.textStepDescription.outlineWidth = 1;
        this.textStepDescription.fontSize = 0.065*this.smallestDimension;
        this.textStepDescription.fontweight = "bold";
        this.textStepDescription.shadowColor = new BABYLON.Color3(0.3, 0, 0, 0.2).toHexString();
        this.textStepDescription.shadowOffsetX = 2;
        this.textStepDescription.shadowOffsetY = 2;
        this.textStepDescription.shadowBlur = 5;
        this.textStepDescription.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        this.textStepDescription.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.panelTextBoxBoundary.addControl(this.textStepDescription); 
    }

    createSliderZoom(cameraRef){
        this.sliderZoom = new GUI.ImageBasedSlider();
        this.sliderZoom.minimum = 1;
        this.sliderZoom.maximum = 8;
        this.sliderZoom.value = 4;
        this.sliderZoom.thumbWidth = (this.canvas.height*0.1)+"px";
        this.sliderZoom.isVisible = false;
        this.sliderZoom.isVertical = true;
        this.sliderZoom.heightInPixels = this.canvas.height*0.6;
        this.sliderZoom.widthInPixels = this.canvas.width*0.1;
        this.sliderZoom.thumbImage = new GUI.Image("thumb", "https://charliebehan.github.io/DromoneARDemo/textures/ZoomIcon.png");
        this.sliderZoom.onValueChangedObservable.add(function(value) {
            cameraRef.radius = value;
        });   
        this.sliderZoom.onPointerDownObservable.add(function(point, data) {
            window.navigator.vibrate(50);
        });
        this.sliderZoom.onPointerUpObservable.add(function(point, data) {
            window.navigator.vibrate(50);
        });
        this.sliderZoom.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        this.sliderZoom.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        this.sliderZoom.displayValueBar = false;
        this.advancedTexture.addControl(this.sliderZoom);  
    }

    createAnimationButtons(productObjectRef){
        var animations = productObjectRef.animations;

        this.gridAnimationTypeButtons = new GUI.Grid();   
        this.advancedTexture.addControl(this.gridAnimationTypeButtons); 
        this.gridAnimationTypeButtons.isVisible = false;

        
        this.gridAnimationTypeButtons.widthInPixels = this.smallestDimension*0.8;//"750px";
        this.gridAnimationTypeButtons.heightInPixels = this.smallestDimension*0.21;
        this.gridAnimationTypeButtons.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.gridAnimationTypeButtons.topInPixels = -this.smallestDimension*0.02;

        for(var i = 0; i < animations.length; i++){
            var animationRef = animations[i];
            this.gridAnimationTypeButtons.addRowDefinition(this.smallestDimension*0.07, true);
            var buttonAnimation = this.createAnimationButton(i,animations[i].animationName,animationRef);      
            this.gridAnimationTypeButtons.addControl(buttonAnimation, i, 0); 
            this.buttonsAnimationType.push(buttonAnimation);
        }
        var textBlock = new GUI.TextBlock("Header", "Select the procedure you would like to complete.");
        textBlock.textWrapping = true;
        //textBlock.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        textBlock.paddingTopInPixels = -this.canvas.height+(this.canvas.height*0.4);
        //textBlock.widthInPixels = this.smallestDimension;
        textBlock.fontSize = 0.05*this.smallestDimension;
        textBlock.isEnabled = false;
        textBlock.color = "white";
        textBlock.shadowColor = new BABYLON.Color3(0.3, 0, 0, 0.2).toHexString();
        textBlock.shadowOffsetX = 2;
        textBlock.shadowOffsetY = 2;
        textBlock.shadowBlur = 5;
        textBlock.outlineColor = "black";
        textBlock.outlineWidth = 1;
        //textBlock.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        //textBlock.topInPixels = this.canvas.height-this.gridAnimationTypeButtons.heightInPixels-150;
        this.textButtonExplainer = textBlock;
        this.advancedTexture.addControl(this.textButtonExplainer);
        this.textButtonExplainer.isVisible = false;
        //this.textButtonExplainer.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        
    }

    createAnimationButton(name, text,animationRef) {
        var result = new GUI.Button(name);
        result.widthInPixels = this.smallestDimension*0.8;
        result.heightInPixels = this.smallestDimension*0.06;
        result.color = "transparent";
        result.cornerRadius = 20;
        result.shadowColor = new BABYLON.Color3(0.4, 0, 0, 0.05).toHexString();
        result.shadowOffsetX = 0;
        result.shadowOffsetY = 0;
        result.shadowBlur = 2;
        result.background = new BABYLON.Color3(0.9, 0.2, 0.2, 0.6).toHexString();
      
        /* var iconImage = new GUI.Image(name + "_icon", "https://charliebehan.github.io/DromoneARDemo/textures/AnimationButtonOff.png");
        iconImage.width = "88%";
        iconImage.paddingBottom = "10%";
        iconImage.color = "transparent"
        result.addControl(iconImage); */
    
        var textBlock = new GUI.TextBlock(name + "_button", text);
        textBlock.textWrapping = true;
        textBlock.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        //textBlock.paddingTop = "80%";
        textBlock.fontSize = 0.04*this.smallestDimension;
        textBlock.color = "white";
        /* textBlock.shadowColor = new BABYLON.Color3(0.6, 0, 0, 0.2).toHexString();
        textBlock.shadowOffsetX = 0;
        textBlock.shadowOffsetY = 0;
        textBlock.shadowBlur = 5; */
        result.addControl(textBlock);
      
        return result;
    }

    createProcedureCompleteImage(){
        this.imageProcedureComplete = new GUI.Image("but", "https://charliebehan.github.io/DromoneARDemo/textures/ProcedureComplete.png");
        this.imageProcedureComplete.width = "360px";
        this.imageProcedureComplete.height = "270px";
        this.imageProcedureComplete.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        this.imageProcedureComplete.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        this.advancedTexture.addControl(this.imageProcedureComplete);
        this.imageProcedureComplete.isVisible = false;
    }

    createHomeButton() {
        this.buttonHome = new GUI.Button("HomeButton");
        this.buttonHome.widthInPixels = this.smallestDimension*0.15;
        this.buttonHome.heightInPixels = this.smallestDimension*0.15;
        this.buttonHome.topInPixels = this.smallestDimension*0.02;
        this.buttonHome.leftInPixels = this.smallestDimension*0.02;
        this.buttonHome.color = "transparent";
      
        var iconImage = new GUI.Image(name + "_icon", "https://charliebehan.github.io/DromoneARDemo/textures/HomeIcon.png");
        //iconImage.width = "88%";
        //iconImage.paddingBottomInPixels = -this.smallestDimension*0.1;;
        iconImage.color = "transparent";
        this.buttonHome.addControl(iconImage);
    
        this.buttonHome.isEnabled = false;
        this.buttonHome.isVisible = false;
        this.buttonHome.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        this.buttonHome.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.advancedTexture.addControl(this.buttonHome); 
    }

    createBasePopUp(productRef){
        this.popUp = new PopUp(this.canvas, 
            this.advancedTexture, productRef, productRef.introImage, productRef.introText);    
    }

    createARInstructions(isARActive){
        this.imageARInstructions = new GUI.Image("but", "https://charliebehan.github.io/DromoneARDemo/textures/ARInstructions.png");
        this.imageARInstructions.widthInPixels = (this.smallestDimension/1000)*638;
        this.imageARInstructions.heightInPixels = (this.smallestDimension/1000)*500;
        this.imageARInstructions.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        this.imageARInstructions.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        this.advancedTexture.addControl(this.imageARInstructions);
        console.log("ARactive = "+isARActive)
        if(isARActive == true){
            this.imageARInstructions.isVisible = true;
            this.imageARInstructions.isEnabled = true; 
        }else{
            this.imageARInstructions.isVisible = false;
            this.imageARInstructions.isEnabled = false; 
        }
    }

    createARPlacementButton(isARActive){
        this.buttonARPlaceProduct = GUI.Button.CreateSimpleButton("buttonARPlaceProduct", "Place Here");
        this.buttonARPlaceProduct.width = this.buttonSizeBig+"px";
        this.buttonARPlaceProduct.height = this.buttonSizeBig/4+"px";
        this.buttonARPlaceProduct.textBlock.fontSize = 25;
        this.buttonARPlaceProduct.thickness = 0;
        this.buttonARPlaceProduct.color = "white";
        this.buttonARPlaceProduct.cornerRadius = 20;
        this.buttonARPlaceProduct.background = "green";
        this.buttonARPlaceProduct.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        this.buttonARPlaceProduct.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        this.advancedTexture.addControl(this.buttonARPlaceProduct);  
        this.buttonARPlaceProduct.isVisible = false;
        if(isARActive == true){
            this.buttonARPlaceProduct.textBlock.text = "Place Here"
            this.buttonARPlaceProduct.background = "green" 
            this.buttonARPlaceProduct.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
            this.buttonARPlaceProduct.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
            this.buttonARPlaceProduct.top = "0px";
            this.buttonARPlaceProduct.left = "0px"; 
        }else{
            this.buttonARPlaceProduct.isVisible = false;
            this.buttonARPlaceProduct.isEnabled = false; 
        }
        
    }

    createARToggle(isARActive){
        this.buttonARToggleOff = new GUI.Button("toggle");
        this.buttonARToggleOff.widthInPixels = this.smallestDimension*0.2;
        this.buttonARToggleOff.heightInPixels = this.smallestDimension*0.2;
        this.buttonARToggleOff.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        this.buttonARToggleOff.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        this.buttonARToggleOff.leftInPixels = -this.smallestDimension*0.02;
        console.log("ARactive = "+isARActive)
        if(isARActive == false){
            this.buttonARToggleOff.isVisible = true;
            this.buttonARToggleOff.isEnabled = true; 
        }else{
            this.buttonARToggleOff.isVisible = false;
            this.buttonARToggleOff.isEnabled = false; 
        }
        this.buttonARToggleOff.color = "transparent";

        var iconImage = new GUI.Image(name + "_icon", "https://charliebehan.github.io/DromoneARDemo/textures/ARToggleOff.png");
        iconImage.color = "transparent";
        this.buttonARToggleOff.addControl(iconImage);
        this.advancedTexture.addControl(this.buttonARToggleOff);


        this.buttonARToggleOn = new GUI.Button("toggle");
        this.buttonARToggleOn.widthInPixels = this.smallestDimension*0.2;
        this.buttonARToggleOn.heightInPixels = this.smallestDimension*0.2;
        this.buttonARToggleOn.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        this.buttonARToggleOn.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        this.buttonARToggleOn.leftInPixels = -this.smallestDimension*0.02;
        if(isARActive == true){
            this.buttonARToggleOn.isVisible = true;
            this.buttonARToggleOn.isEnabled = true;
        }else{
            this.buttonARToggleOn.isVisible = false;
            this.buttonARToggleOn.isEnabled = false;
        }
        this.buttonARToggleOn.color = "transparent";

        var iconImage = new GUI.Image(name + "_icon", "https://charliebehan.github.io/DromoneARDemo/textures/ARToggleOn.png");
        iconImage.color = "transparent";
        this.buttonARToggleOn.addControl(iconImage);
        this.advancedTexture.addControl(this.buttonARToggleOn);
    }

    createJoysticks(product) {
        this.joystickLeft = new Joystick(this.canvas, this.advancedTexture, product, "left");
        this.joystickRight = new Joystick(this.canvas, this.advancedTexture, product, "right");
    }

    createControlPanel(product) {
        var panelUnit = this.smallestDimension/650;
        this.imageControlPanel = new GUI.Image("but", "https://charliebehan.github.io/DromoneARDemo/textures/controlBoxBlank.png");
        this.imageControlPanel.widthInPixels = (panelUnit)*200;
        this.imageControlPanel.heightInPixels = (panelUnit)*335;
        this.imageControlPanel.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.imageControlPanel.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.imageControlPanel.topInPixels = -30;
        this.imageControlPanel.leftInPixels = 50;
        this.advancedTexture.addControl(this.imageControlPanel);
        this.imageControlPanel.isVisible = false;

        this.gridControlPanel = new GUI.Grid();   
        this.advancedTexture.addControl(this.gridControlPanel); 
        this.gridControlPanel.isVisible = false;
        this.gridControlPanel.widthInPixels = (panelUnit)*200;
        this.gridControlPanel.heightInPixels = (panelUnit)*335;
        this.gridControlPanel.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.gridControlPanel.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.gridControlPanel.topInPixels = -30;
        this.gridControlPanel.leftInPixels = 50;

        this.gridControlPanel.addRowDefinition((panelUnit)*79, true);  
        this.gridControlPanel.addRowDefinition((panelUnit)*84, true); 
        this.gridControlPanel.addRowDefinition((panelUnit)*172, true); 
        
        this.buttonControlPanelPower = new GUI.Button("powerButton");
        this.buttonControlPanelPower.widthInPixels = (panelUnit)*200;
        this.buttonControlPanelPower.heightInPixels = (panelUnit)*79;
        this.buttonControlPanelPower.color = "transparent";
        var iconImage = new GUI.Image(name + "_icon", "https://charliebehan.github.io/DromoneARDemo/textures/controlBoxPowerButton.png");
        iconImage.color = "transparent";
        iconImage.widthInPixels = (panelUnit)*200;
        iconImage.heightInPixels = (panelUnit)*79;
        this.buttonControlPanelPower.addControl(iconImage);
        this.buttonControlPanelPower.onPointerUpObservable.add(function(point, data) {
            product.checkControlPanelInput(data.currentTarget.name);
            window.navigator.vibrate(50);
        });

        this.buttonControlPanelControl = new GUI.Button("controlButton");
        this.buttonControlPanelControl.widthInPixels = (panelUnit)*200;
        this.buttonControlPanelControl.heightInPixels = (panelUnit)*79;
        this.buttonControlPanelControl.color = "transparent";
        iconImage = new GUI.Image(name + "_icon", "https://charliebehan.github.io/DromoneARDemo/textures/controlBoxControlButton.png");
        iconImage.color = "transparent";
        iconImage.widthInPixels = (panelUnit)*200;
        iconImage.heightInPixels = (panelUnit)*84;
        this.buttonControlPanelControl.addControl(iconImage);
        this.buttonControlPanelControl.onPointerUpObservable.add(function(point, data) {
            product.checkControlPanelInput(data.currentTarget.name);
            window.navigator.vibrate(50);
        });

        this.gridControlPanel.addControl(this.buttonControlPanelPower, 0, 0); 
        this.gridControlPanel.addControl(this.buttonControlPanelControl, 1, 0); 
    }

    updateUISizes(){
        this.imageLogo = null;
        this.imageARInstructions = null;
        this.imageControlPanel = null;
        this.imageProcedureComplete = null;
        this.joystickLeft = null;
        this.joystickRight = null;
        this.popUp = null;
        this.buttonARPlaceProduct = null;
        this.buttonARToggleOn = null;
        this.buttonARToggleOff = null;
        this.buttonControlPanelPower = null;
        this.buttonControlPanelControl = null;
        this.buttonHome = null;
        this.buttonsAnimationType = [];
        this.textStepDescription = null;
        this.textPopUpDescription = null;
        this.textButtonExplainer = null;
        this.panelTextBoxBoundary = null;
        this.panelPopUpBoundary = null;
        this.blackout = null;
        this.sliderZoom = null;
        this.gridAnimationTypeButtons = null;
        this.gridControlPanel = null;
    }
}